import 'arrayq';
import { createSelector } from 'reselect';

import { IEntity } from '../../types';
import { bookmarksResource } from '../bookmarks/resource';
import { selector } from './reducer';
import adminReselectors from '../admin/reselectors';

import { selectors as metaSelectors } from '../../meta/selectors';

export const selectors = {
  active: createSelector(selector, (state) => state.categoryId !== undefined || state.sorting !== 'createdDesc'),
  categoryId: createSelector(selector, (state) => state.categoryId),
  sorting: createSelector(selector, (state) => state.sorting),
  visible: createSelector(selector, (state) => state.visible),
};

const createdSelector = (item: IEntity) => new Date(item.created).getTime();
const sortFuncSelector = createSelector(
    selectors.sorting,
    (order) => {
        if (order === 'createdAsc') {
            // sorting createdAsc.
            return (a: IEntity, b: IEntity) => {
                if (createdSelector(a) !== createdSelector(b)) {
                  return createdSelector(b) - createdSelector(a);
                }
                return a.id - b.id;
            };
        } else if (order === 'pageNumber') {
            // sorting pageNumber.
            return (a: IEntity, b: IEntity) => {
                if (a.pageNumber !== b.pageNumber) {
                  return a.pageNumber - b.pageNumber;
                }
                if (createdSelector(a) !== createdSelector(b)) {
                  return createdSelector(b) - createdSelector(b);
                }
                return a.id - b.id;
            };
        } else {
            // sorting createdDesc.
            return (a: IEntity, b: IEntity) => {
                if (createdSelector(a) !== createdSelector(b)) {
                  return createdSelector(a) - createdSelector(b);
                }
                return b.id - a.id;
            };
        }
    },
);

const notesCurrentPage = createSelector(
  adminReselectors.notesItemsSelector,
  metaSelectors.pageId,
  (notes, pageId) => notes.qWhere((x) => x.pageId === pageId && !x.isquestion),
);

const notesSharedCurrentPage = createSelector(
  adminReselectors.notesSharedSelector,
  metaSelectors.pageId,
  (notes, pageId) => notes.qWhere((x) => x.pageId === pageId && !x.isquestion),
);

const questionsCurrentPage = createSelector(
  adminReselectors.questionsItemsSelector,
  metaSelectors.pageId,
  (questions, pageId) => questions.qWhere((x) => x.pageId === pageId),
); 

const notesAndQuestionsCurrentPage = createSelector(
  adminReselectors.notesItemsSelector,
  adminReselectors.notesSharedSelector,
  adminReselectors.questionsItemsSelector,
  metaSelectors.pageId,
  (notes, sharednotes, questions, pageId) => notes.concat(sharednotes).concat(questions).qWhere((x) => x.pageId === pageId),
);

export const notesAndQuestionsPageSelector = notesAndQuestionsCurrentPage;

export const notesCurrentPageSelector = notesCurrentPage;
export const notesSharedCurrentPageSelector = notesSharedCurrentPage;

export const questionsCurrentPageSelector = questionsCurrentPage;

export const notesSelector = createSelector(
    adminReselectors.notesItemsSelector,
    adminReselectors.notesSharedSelector,
    adminReselectors.questionsItemsSelector,
    (items, itemsshared, questions) => items.concat(itemsshared).concat(questions),
);
export const bookmarksSelector = createSelector(
    bookmarksResource.selectors.items,
    selectors.categoryId,
    sortFuncSelector,
    (items, categoryId, sort) => categoryId !== undefined ? items.qWhere((x) => (x.categoryId || 0) === categoryId).sort(sort) : items.slice(0).sort(sort),
);



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/note/pageFilter/selectors.tsx